import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { AdminGuard } from './common/AdminGuard';
import { NotfoundComponent } from './shared/pages/notfound/notfound.component';

/**
 * Route configuration using lazy loading approach
 * see https://angular.io/guide/lazy-loading-ngmodule for more info
 */


const routes: Routes = [
  {
    path: 'view',
    loadChildren: () => import('src/app/viewer/viewer-routing.module').then(m => m.ViewerRoutingModule),
    runGuardsAndResolvers: 'always',
    canActivate: [MsalGuard]
  },
  {
    path: 'snapshot/:cameraId/:time',
    loadChildren: () => import('src/app/viewer/viewer-routing.module').then(m => m.ViewerRoutingModule),
    runGuardsAndResolvers: 'always',
    canActivate: [MsalGuard]
  },
  {
    path: 'admin',
    loadChildren: () => import('src/app/admin/admin-routing.module').then(m => m.AdminRoutingModule),
    canActivate: [AdminGuard, MsalGuard],
  },
  {
    path: '**',
    component: NotfoundComponent,
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {})],
  exports: [RouterModule],
})
export class AppRoutingModule { }
